import './App.css';
import React from 'react';
import { Home } from './Comp/Home';
import { BrowserRouter,Routes, Route, Navigate, } from 'react-router-dom';
import { Cards } from './Comp/Cards';
import { Navbar } from './Nav/Navbar';
import { Statistics } from './Comp/Statistics';
import 'bootstrap/dist/css/bootstrap.min.css';
import Topbar from './Nav/Topbar';
import { useEffect, useState } from 'react';
import LoginPage from './Comp/LoginPage';
import { Rewards } from './Comp/Rewards';
// import { LoginPage } from './Comp/LoginPage';

function App() {
  const [isLoginPage, setIsLoginPage] = useState(window.location.pathname === "/login");

  useEffect(() => {
    const checkLocation = setInterval(() => {
      if (window.location.pathname === "/login" && !isLoginPage) {
        setIsLoginPage(true);
      } else if (window.location.pathname !== "/login" && isLoginPage) {
        setIsLoginPage(false);
      }
    }, 100); // Checks every 100ms

    return () => clearInterval(checkLocation);
  }, [isLoginPage]);

  
  

  return (
    <div className="App">
      <BrowserRouter>
        <div className='d-flex'>
              <div className="w-auto position-fixed">
                {!isLoginPage &&  <Navbar/>}
              </div>
              <div className="invisible">
                {!isLoginPage &&  <Navbar/>}
              </div>
              <div className='col overflow-auto'>
                {!isLoginPage &&  <Topbar/> }
                <div className='main-con'>
                    <Routes>
                          <Route path='/' element={<Home/>} />
                          <Route path='/login' element={<LoginPage/>} />
                          <Route path='/cards' element={<Cards/>} />
                          <Route path='/rewards' element={<Rewards/>} />
                          <Route path='/statistics' element={<Statistics/>} />
                          <Route path="*" element={<Navigate to="/" />} />
                      </Routes>
                </div>
                  
              </div>
        </div>
        
          
      </BrowserRouter>
    </div>
  );
}

export default App;
